import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

const FloatingCourseActionsBar: React.FC = () => {
    const {
        previousButtonTitle,
        nextButtonTitle,
        saveButtonTitle,
        currentStep,
        totalSteps,
        onSave,
        saveDisabled,
        onPrevious,
        onNext,
        previewDisabled,
        nextDisabled,
        blockUi,
    } = useSelector((state: ApplicationState) => state.common.data.floatingCourseActionsBarConfiguration);

    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));

    const [progressWidth, setProgressWidth] = useState<number>(0);

    useEffect(() => {
        setProgressWidth((currentStep / totalSteps) * 100);
    }, [currentStep, totalSteps]);

    const handleSaveClick = () => {
        onSave();
    };

    const handlePreviousClick = () => {
        onPrevious();
    };

    const handleNextClick = () => {
        onNext();
    };

    return (
        <>
            {blockUi && <div className="blockUi"></div>}
            <div className="floating-course-actions-container">
                <div className="button-save-container">
                    <button className="btn btn-light btn-save" disabled={saveDisabled} onClick={handleSaveClick}>
                        <span>{saveButtonTitle}</span>
                    </button>
                </div>

                <div className="step-container">
                    <div className="progress-bar">
                        <div className="progress" style={{ width: progressWidth + '%' }} />
                    </div>

                    <div className="step-info">
                        <span>{strings.STEP_OF.replace('%n', currentStep.toString()).replace('%t', totalSteps.toString())}</span>
                    </div>
                </div>

                <div className="navigation-container">
                    <button className="btn btn-light" disabled={previewDisabled} onClick={handlePreviousClick}>
                        <span>{previousButtonTitle}</span>
                    </button>
                    <button className="btn btn-primary" disabled={nextDisabled} onClick={handleNextClick}>
                        <span>{nextButtonTitle}</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default FloatingCourseActionsBar;
